var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mentor (Messages)",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1153 -477)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-33 -88H287V229H-33V-88Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-33 229H-34V230H-33V229ZM287 228H-33V230H287V228ZM-32 229V-88H-34V229H-32Z",
    fill: "#E0E0E0",
    mask: "url(#path-1-inside-1_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 163166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 162918"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 12,
    cy: 11,
    r: 20,
    fill: "#D6E2F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4818 17.8996L4.2168 14.6288L7.49722 3.36377L18.7623 6.63457L15.4818 17.8996ZM5.91954 13.6957L14.5583 16.2065L17.0691 7.56772L8.43036 5.05689L5.91954 13.6957Z",
    fill: "#1E2D66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7545 9.64551C12.3125 9.64551 12.7454 10.0784 12.7454 10.6364C12.7454 11.1943 12.3125 11.6272 11.7545 11.6272C11.1966 11.6272 10.7637 11.1943 10.7637 10.6364C10.7733 10.0784 11.2062 9.64551 11.7545 9.64551ZM11.0715 12.3295H12.4376V18.6691H11.0715V12.3295Z",
    fill: "#1E2D66"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-1153 -477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project_icon.055f90ecc6b4bda0f0f4537865a0770f.svg";
export { ForwardRef as ReactComponent };